import { Button, makeStyles, tokens } from '@fluentui/react-components'
import { ErrorCircle24Regular, ArrowClockwise24Regular } from '@fluentui/react-icons'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    gap: '16px',
    padding: '24px',
    backgroundColor: tokens.colorNeutralBackground1,
    textAlign: 'center',
  },
  icon: {
    color: tokens.colorPaletteRedForeground1,
    fontSize: '48px',
  },
  title: {
    fontSize: '20px',
    fontWeight: '600',
    color: tokens.colorNeutralForeground1,
    margin: 0,
  },
  message: {
    color: tokens.colorNeutralForeground2,
    fontSize: '14px',
    maxWidth: '400px',
    lineHeight: '1.5',
    margin: 0,
  },
})

interface ErrorStateProps {
  title?: string
  message?: string
  onRetry?: () => void
}

export function ErrorState({ 
  title = 'Something went wrong', 
  message = 'An unexpected error occurred. Please try again.',
  onRetry 
}: ErrorStateProps) {
  const styles = useStyles()

  return (
    <div className={styles.root}>
      <ErrorCircle24Regular className={styles.icon} />
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.message}>{String(message)}</p>
      {onRetry && (
        <Button 
          appearance="primary" 
          icon={<ArrowClockwise24Regular />}
          onClick={onRetry}
        >
          Try Again
        </Button>
      )}
    </div>
  )
}
